"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemSkeleton = exports.IframeStyle = exports.IFrameContainer = exports.ContainerWrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Nav = require("../Nav/Nav.style");
const {
  colours
} = _uiKit.theme;
const IFrameContainer = exports.IFrameContainer = _styledComponents.default.li.withConfig({
  displayName: "SubMenuWithIframestyles__IFrameContainer",
  componentId: "sc-1njvnc9-0"
})(["background-color:", ";", ";", ";", ";", ";", ";position:relative;display:flex;"], _ref => {
  let {
    hasBg
  } = _ref;
  return hasBg ? colours.WHITE : colours.NEUTRALS_6;
}, props => props.width && "width: ".concat(props.width, "px;"), props => props.maxWidth && "max-width: ".concat(props.maxWidth, "px;"), props => props.height && "height: ".concat(props.height, "px;"), props => props.maxHeight && "max-height: ".concat(props.maxHeight, "px;"), props => props.isMobile && _Nav.mobileContainerDimension);
const IframeStyle = exports.IframeStyle = (0, _styledComponents.default)(_iframeResizerReact.default).withConfig({
  displayName: "SubMenuWithIframestyles__IframeStyle",
  componentId: "sc-1njvnc9-1"
})(["border:none;"]);
const ContainerWrapper = exports.ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "SubMenuWithIframestyles__ContainerWrapper",
  componentId: "sc-1njvnc9-2"
})(["position:absolute;top:0;width:100%;display:flex;flex-direction:column;background:transparent;min-height:170px;"]);
const ItemSkeleton = exports.ItemSkeleton = _styledComponents.default.div.withConfig({
  displayName: "SubMenuWithIframestyles__ItemSkeleton",
  componentId: "sc-1njvnc9-3"
})(["display:block;padding:11px ", ";min-height:30px;border-radius:", ";text-align:left;"], _uiKit.theme.spacing.BASE_2, _uiKit.theme.borderRadius.default);